import { render, staticRenderFns } from "./dashboard-gender.vue?vue&type=template&id=639f8804&scoped=true&"
import script from "./dashboard-gender.vue?vue&type=script&lang=js&"
export * from "./dashboard-gender.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-gender.vue?vue&type=style&index=0&id=639f8804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f8804",
  null
  
)

export default component.exports